import React from "react"
import PropTypes from "prop-types"
import styled from "@emotion/styled"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  max-width: 528px;
`

const Item = styled.a`
  font-size: 16px;
  text-decoration: none;

  ${({ theme }) => theme.breakpoints.down("md")} {
    background: #fff;
    padding: 8px;
    border-radius: 8px;
  }
`

const ItemContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`

const ItemTitle = styled.h3`
  font-size: 22px;
  line-height: 24px;
  font-weight: 700;
  margin: 0;
  margin-bottom: 0;
  color: #1c1c1c;

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: 20px;
    line-height: 24px;
  }

  &:hover {
    color: ${({ theme }) => theme.palette.primary.main};
  }
`

const ItemSubtitle = styled.p`
  font-size: 18px;
  line-height: 22px;
  font-weight: 500;
  color: #4f4f59;
  padding-left: 56px;
  margin: 0;

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: 14px;
    line-height: 18px;
    padding-left: 42px;
  }
`

const ItemImage = styled.img`
  width: 48px;
  height: 48px;
  display: flex;
  margin-bottom: 0;
  justify-content: center;
  align-items: center;

  ${({ theme }) => theme.breakpoints.down("md")} {
    width: 32px;
    height: 32px;
  }
`

const HeaderFeaturedNavList = ({ subItems }) => {
  return (
    <Container>
      {subItems.map((subItem) => (
        <Item href={subItem.link} key={subItem.title}>
          <ItemContent>
            <ItemImage alt={subItem.title} src={subItem.icon.file.url} />
            <ItemTitle>{subItem.title}</ItemTitle>
          </ItemContent>
          <ItemSubtitle>{subItem.subtitle}</ItemSubtitle>
        </Item>
      ))}
    </Container>
  )
}

HeaderFeaturedNavList.propTypes = {
  subItems: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      subtitle: PropTypes.string,
      icon: PropTypes.shape({
        file: PropTypes.shape({
          url: PropTypes.string.isRequired,
        }).isRequired,
      }).isRequired,
    }),
  ).isRequired,
}

export default HeaderFeaturedNavList
